/**
 * @author octopaas
 * @since Apr-2019
 */
import React from 'react';
import '../../css/login.css';
import {connect} from 'react-redux';
import {backToLogin, submitInitChallenge} from '../actions/actions';
import {Link} from 'react-router-dom';
import PropTypes from "prop-types";
import stringifyQuery from 'query-string-for-all'
import {BASE_PATH} from '../utils/APIUtility';

class BypassSSORedirect extends React.Component {
    render() {
        const authEndpoint = process.env.REACT_APP_AUTHORIZE_ENDPOINT;
        let redirect = 'n';
        const {onClick, responseType, clientId, redirectURI, state, codeChallenge, codeChallengeMethod} = this.props;
        const query = stringifyQuery.stringify({client_id: clientId, response_type: responseType, redirect_uri: redirectURI, state: state, redirect: redirect, code_challenge: codeChallenge, code_challenge_method: codeChallengeMethod});
        return (
            <div className="back-to-login">
                <Link to={BASE_PATH + authEndpoint + "?" + query}
                      onClick={() => onClick(responseType, clientId, redirectURI, state, redirect, codeChallenge, codeChallengeMethod)}>
                    Bypass Single Sign-On Redirect
                </Link>
            </div>
        );
    }
}

BypassSSORedirect.propTypes = {
    responseType: PropTypes.string,
    clientId: PropTypes.string,
    redirectURI: PropTypes.string,
    state: PropTypes.string,
    redirect: PropTypes.string,
    codeChallenge: PropTypes.string,
    codeChallengeMethod: PropTypes.string
};

const mapDispatchToProps = (dispatch) => {
    return {
        onClick: (responseType, clientId, redirectURI, state, redirect, codeChallenge, codeChallengeMethod) => {
            dispatch(backToLogin());
            dispatch(submitInitChallenge(responseType, clientId, redirectURI, state, redirect, null, null, null, codeChallenge, codeChallengeMethod));
        }
    }
};

const mapStateToProps = (state) => {
    return {
        responseType: state.login.responseType,
        clientId: state.login.clientId,
        redirectURI: state.login.redirectURI,
        state: state.login.state,
        redirect: state.login.redirect,
        codeChallenge: state.login.codeChallenge,
        codeChallengeMethod: state.login.codeChallengeMethod
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BypassSSORedirect);
